export enum FeedbackMessages {
    Great = 'Thanks! Anything you want to add?',
    Good = 'Any feedback?',
    Neutral = 'Any feedback?',
    Negative = 'How can we improve?',
    VeryNegative = 'Sorry! How can we improve?'
}